import React from 'react';
import { oneOf, object, number } from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { Icon } from '@fiverr-private/fit';
import { r_check } from '@fiverr-private/fit/icons';
import { CHECKOUT_PLANS } from '../../../../utils/packagesUtils/constants';
import { getPackageById, getSelectedCheckoutPlan, getSelectedRecurringOption } from '../../../../reducers/packages';
import { translatePricingSummary } from '../../../../utils/recurring/translation';

import './style.scss';

const RecurringOptionsCol = (
    { currentPrice, selectedRecurringOption, selectedCheckoutPlan },
    { currencyConverter }
) => {

    const { duration, durationTimeUnit, discountPercentage } = selectedRecurringOption;

    const calculateFormattedPrice = () => {
        if (discountPercentage === 0) {
            return currencyConverter.convert(currentPrice);
        }

        const discount = discountPercentage / 100;
        const discountedPrice = currentPrice - (currentPrice * discount);
        const fixedPrice = discountedPrice.toFixed(2);

        return currencyConverter.convert(fixedPrice);
    };

    const isRecurringOrderSelected = selectedCheckoutPlan === CHECKOUT_PLANS.RECURRING_ORDER;

    const formattedPrice = calculateFormattedPrice();
    const recurringPricingSummary = translatePricingSummary({
        formattedPrice, duration, durationTimeUnit
    });

    const wrapperClass = classNames(
        'recurring-options-col',
        { 'recurring-order': isRecurringOrderSelected }
    );

    return (
        <td className={wrapperClass}>
            <Icon size={14} className="selected-icon">
                {r_check}
            </Icon>
            {isRecurringOrderSelected && <p className="tbody-6">
                {recurringPricingSummary}
            </p>
            }
        </td>
    );
};

RecurringOptionsCol.propTypes = {
    currentPrice: number.isRequired,
    selectedRecurringOption: object.isRequired,
    selectedCheckoutPlan: oneOf(Object.values(CHECKOUT_PLANS)).isRequired
};

RecurringOptionsCol.contextTypes = {
    currencyConverter: object
};

const mapStateToProps = ({ packages }, { packageId }) => {
    const { currentPrice } = getPackageById(packages, packageId);
    const selectedRecurringOption = getSelectedRecurringOption(packages);
    const selectedCheckoutPlan = getSelectedCheckoutPlan(packages);

    return { currentPrice, selectedRecurringOption, selectedCheckoutPlan };
};

export { RecurringOptionsCol };
export default connect(mapStateToProps)(RecurringOptionsCol);
